import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
    selector: 'app-best-lms-for-schools-india',
    templateUrl: './best-lms-for-schools-india.component.html',
    styleUrls: ['./best-lms-for-schools-india.component.scss']
})
export class BestLmsForSchoolsIndiaComponent implements OnInit {

    constructor(
        private titleService: Title,
        private metaService: Meta,
        private seoService: SeoServiceService
    ) { }

    ngOnInit(): void {
        this.seoService.createLinkForCanonicalURL();
        this.titleService.setTitle('Best LMS for Schools in India | Unified Learning Management System');
        this.metaService.updateTag({ name: 'description', content: 'Looking for the Best LMS for Schools in India? Discover how a unified Learning Management System connects students, teachers, parents & management on one powerful platform.' });
        this.metaService.updateTag({ name: 'keywords', content: 'Best LMS for Schools in India, Learning Management System for schools, School LMS platform, Unified LMS for colleges, Digital school management system' });
    }

}
